import { getCostsUnit } from '@/utils/pathwayTemplateUtils';
import WaterfallChart from '../charts/WaterfallChart';
import { parseTEAData } from '@/utils/analysisUtils';
import { useTeaData } from '@/stores/pathwayTemplateAnalysisStore';
import TeaControl from '@/components/pathwayNavigator/TeaControl';
import LoadingSkeleton from '../core/LoadingSkeleton';

const CostsChart = () => {
  const { data, loading, error } = useTeaData();

  if (loading && !data) return <LoadingSkeleton />;
  if (error) return <div>Error: {error.message}</div>;

  const unit = getCostsUnit(data);
  const results = parseTEAData(data);

  return (
    <>
      <WaterfallChart data={results} label="" yAxisLabel={`Costs by Component\n[${unit}]`} />
      <TeaControl />
    </>
  );
};

export default CostsChart;
